import type {
  PaginationDetailsWithKey,
  FileCsvUploadEntries,
  ContactList,
  FileUploadAdditionalDetails,
  ContactListFilters,
  EditContactListData,
} from 'src/types/contacts-genesis';
import type {ContactsGenesisActions} from 'src/action-creators/contacts-genesis';

import {
  RESET_PAGINATION_DATA,
  SET_PAGINATION_DATA,
  SET_CSV_FILE_UPLOAD_HEADERS,
  SET_CSV_FILE_UPLOAD_ENTRIES,
  SET_CONTACT_LISTS_DATA,
  SET_FILE_UPLOAD_ADDITIONAL_DETAILS,
  SET_CSV_FILE_UPLOAD,
  SET_CONTACT_LISTS_FOR_UPLOAD,
  UPDATE_CONTACT_LIST_LIMIT_REACHED,
  SET_ARCHIVED_CONTACT_LISTS_DATA,
  SET_CONTACT_LISTS_FILTER,
  UPDATE_CONTACT_LIST_DATA,
  REMOVE_CONTACT_LIST_FROM_STATE,
  SET_EDIT_CONTACT_LISTS_DATA,
  SET_CONTACT_PHONE_NUMBER,
  SET_CONTACT_LIST_ID_FOR_CONTACT_CREATION,
} from 'src/action-creators/contacts-genesis';
import {
  initialPaginationDetails,
  initialContactListFilters,
  initialAdditionalFileDetails,
  allInitialPaginationDetails,
} from 'src/components/contacts-genesis/contacts-genesis-constants';


type ContactsState = {
  paginationDetails: PaginationDetailsWithKey;
  fileCsvUploadHeaders: string[];
  fileCsvUploadEntries: FileCsvUploadEntries[];
  fileCsvUpload: File | null;
  fileUploadAdditionalDetails: FileUploadAdditionalDetails;
  contactsListData: ContactList[];
  editContactListsData: EditContactListData;
  archivedContactsListData: ContactList[];
  contactListsForUploadScreen: ContactList[];
  contactListLimitReached: boolean;
  contactListFilters: ContactListFilters;
  contactPhoneNumber: string;
  contactListIdForContactCreation: string;
};

const initialState: ContactsState = {
  paginationDetails: allInitialPaginationDetails,
  fileCsvUploadHeaders: [],
  fileCsvUploadEntries: [],
  fileCsvUpload: null,
  contactsListData: [],
  editContactListsData: {title: '', description: ''},
  archivedContactsListData: [],
  fileUploadAdditionalDetails: initialAdditionalFileDetails,
  contactListsForUploadScreen: [],
  contactListLimitReached: false,
  contactListFilters: initialContactListFilters,
  contactPhoneNumber: '',
  contactListIdForContactCreation: '',
};

export default (
  state: ContactsState | null | undefined = initialState,
  action: ContactsGenesisActions,
): ContactsState => {
  switch (action.type) {
    case SET_CONTACT_LIST_ID_FOR_CONTACT_CREATION: {
      // @ts-expect-error - TS2322 - Type '{ contactListIdForContactCreation: string; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 8 more ...; contactPhoneNumber?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactListIdForContactCreation: action.payload,
      };
    }
    case SET_CONTACT_PHONE_NUMBER:
      // @ts-expect-error - TS2322 - Type '{ contactPhoneNumber: string; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 8 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactPhoneNumber: action.payload,
      };
    case SET_CSV_FILE_UPLOAD_HEADERS:
      // @ts-expect-error - TS2322 - Type '{ fileCsvUploadHeaders: string[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        fileCsvUploadHeaders: action.payload,
      };
    case SET_CSV_FILE_UPLOAD_ENTRIES:
      // @ts-expect-error - TS2322 - Type '{ fileCsvUploadEntries: FileCsvUploadEntries[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        fileCsvUploadEntries: action.payload,
      };
    case SET_CSV_FILE_UPLOAD:
      // @ts-expect-error - TS2322 - Type '{ fileCsvUpload: File | null; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 8 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        fileCsvUpload: action.payload,
      };

    // @ts-expect-error - TS2678 - Type '"contacts/resetPaginationData"' is not comparable to type '"contacts/setCsvFileUploadHeaders" | "contacts/setCsvFileUploadEntries" | "contacts/setPaginationData" | "contacts/setContactListsFilter" | "contacts/setCsvFileUpload" | ... 6 more ... | "contacts/setContactListIdForContactCreation"'.
    case RESET_PAGINATION_DATA:
      // @ts-expect-error - TS2322 - Type '{ paginationDetails: PaginationDetailsWithKey; fileCsvUploadHeaders?: string[] | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {...state, paginationDetails: allInitialPaginationDetails};
    case SET_PAGINATION_DATA:
      const {key, paginationDetails} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ paginationDetails: { [x: string]: PaginationDetails | { currentPage?: number; totalPages?: number; itemsPerPage?: number; }; }; fileCsvUploadHeaders?: string[] | undefined; ... 10 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        paginationDetails: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.paginationDetails,
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          [key]: {...state.paginationDetails[key], ...paginationDetails},
        },
      };
    case SET_CONTACT_LISTS_DATA:
      const updateList = action.payload.update;
      const receivedContactList = action.payload.contactLists;
      // @ts-expect-error - TS2322 - Type '{ contactsListData: ContactList[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactsListData: updateList
          ? // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            [...state.contactsListData, ...receivedContactList]
          : receivedContactList,
      };
    case SET_ARCHIVED_CONTACT_LISTS_DATA:
      const updateArchivedList = action.payload.update;
      const receivedArchivedContactList = action.payload.contactLists;
      // @ts-expect-error - TS2322 - Type '{ archivedContactsListData: ContactList[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        archivedContactsListData: updateArchivedList
          ? // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            [...state.contactsListData, ...receivedArchivedContactList]
          : receivedArchivedContactList,
      };
    case SET_FILE_UPLOAD_ADDITIONAL_DETAILS:
      // @ts-expect-error - TS2322 - Type '{ fileUploadAdditionalDetails: FileUploadAdditionalDetails; paginationDetails?: PaginationDetailsWithKey | undefined; ... 10 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        fileUploadAdditionalDetails: action.payload,
      };
    case SET_CONTACT_LISTS_FOR_UPLOAD:
      // @ts-expect-error - TS2322 - Type '{ contactListsForUploadScreen: ContactList[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactListsForUploadScreen: action.payload,
      };
    case SET_CONTACT_LISTS_FILTER:
      // reset pagination details when filters change
      // @ts-expect-error - TS2322 - Type '{ contactListFilters: ContactListFilters; paginationDetails: PaginationDetailsWithKey; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactListFilters: action.payload,
        paginationDetails: allInitialPaginationDetails,
      };
    case UPDATE_CONTACT_LIST_DATA: {
      const {id, starred} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const selectedList = state.contactsListData.find(
        (contactsList) => contactsList.id === id,
      );
      if (!selectedList) {
        // @ts-expect-error - TS2322 - Type 'ContactsState | null' is not assignable to type 'ContactsState'.
        return state;
      }

      selectedList.starred = starred;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const newList = [...state.contactsListData];
      // @ts-expect-error - TS2322 - Type '{ contactsListData: ContactList[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {...state, contactsListData: newList};
    }
    // @ts-expect-error - TS2678 - Type '"contacts/removeContactListFromState"' is not comparable to type '"contacts/setCsvFileUploadHeaders" | "contacts/setCsvFileUploadEntries" | "contacts/setPaginationData" | "contacts/setContactListsFilter" | "contacts/setCsvFileUpload" | ... 6 more ... | "contacts/setContactListIdForContactCreation"'.
    case REMOVE_CONTACT_LIST_FROM_STATE: {
      // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
      const id = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const filteredList = state.contactsListData.filter(
        (contactsList) => contactsList.id !== id,
      );
      // @ts-expect-error - TS2322 - Type '{ contactsListData: ContactList[]; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; ... 9 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        contactsListData: filteredList,
      };
    }
    // @ts-expect-error - TS2678 - Type '"contacts/setEditContactListsData"' is not comparable to type '"contacts/setCsvFileUploadHeaders" | "contacts/setCsvFileUploadEntries" | "contacts/setPaginationData" | "contacts/setContactListsFilter" | "contacts/setCsvFileUpload" | ... 6 more ... | "contacts/setContactListIdForContactCreation"'.
    case SET_EDIT_CONTACT_LISTS_DATA: {
      // @ts-expect-error - TS2322 - Type '{ editContactListsData: any; paginationDetails?: PaginationDetailsWithKey | undefined; fileCsvUploadHeaders?: string[] | undefined; fileCsvUploadEntries?: FileCsvUploadEntries[] | undefined; ... 8 more ...; contactListIdForContactCreation?: string | undefined; }' is not assignable to type 'ContactsState'.
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        editContactListsData: action.payload,
      };
    }
    default:
      // @ts-expect-error - TS2322 - Type 'ContactsState | null' is not assignable to type 'ContactsState'.
      return state;
  }
};
